import { Injectable, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { delay, tap } from "rxjs";
import { BodyListResponse } from "src/app/core/models/general/body-list-response";
import { ConfiguracionSistemaDTO } from "src/app/core/models/general/configuracionSistema-DTO";
import { SeguridadUsuarioEncritacion } from "src/app/core/models/general/seguridad-usuario-encriptacion";
import { ConfiguracionSistemaService } from "src/app/shared/services/general/configuracionSistema/configuracionSistema.service";
import { environment } from "src/environments/environment";
const tiempoEspera = environment.tiempoEspera;
@Injectable()
export class ConsultasUtilGenerales implements OnInit {
  public seguridadUsuarioEncritacion: SeguridadUsuarioEncritacion;
  public usuarioConectado!: any;
  private configuracionGeneral: ConfiguracionSistemaDTO[] = [];
  constructor(
    private configuracionSistemaService: ConfiguracionSistemaService
  ) {

    this.seguridadUsuarioEncritacion = new SeguridadUsuarioEncritacion();
    this.usuarioConectado = this.seguridadUsuarioEncritacion.desencriptarUsuarioNuevo();

  }

  ngOnInit() {

  }


  getConfiguracion(codigo: string, resultado: any) {
    console.log('1')
      this.configuracionSistemaService
        .getConfiguracionSistemaPorCodigoIdentificacioncionService(codigo)
        .pipe(
          tap((data: BodyListResponse<ConfiguracionSistemaDTO>) => {
            this.configuracionGeneral = data.data;
            resultado = this.configuracionGeneral[0].value;
            console.log('El resultado de la consulta:', resultado)
          }),
          delay(tiempoEspera),
        )
        .subscribe();

  }

}
